//Prod-API
export const environment = {
  production: true,
  apiUrl: 'https://busly-api-prod-a9djf7azebayczby.centralus-01.azurewebsites.net',
  uiUrl: 'https://login.busly.tech/',
};
